import { copyTextToClipboard } from '@tma.js/sdk';

export const CheckIsNull = (value) =>
  value === "" || value === undefined || value === null;

export const IsDefined = (value) => value !== undefined && value !== null;

export const toAbsoluteUrl = (url) => {
  const newUrl = url[0] === "/" ? url : "/" + url;

  return window.location.origin + newUrl;
};

export const ResolveArrayNull = (array) => {
  return array ? array : [];
};

export const IsAlphaNumeric = (e) => {
  const alphanumericRegex = /^[a-zA-Z0-9]+$/;
  const key = e.key;

  return alphanumericRegex.test(key);
};

export const IsKeyPressNumber = (e) => {
  return (
    e.code.includes("Digit") ||
    e.ctrlKey ||
    e.code === "Backspace" ||
    e.code.includes("Arrow")
  );
};

export const CopyToClipboard = (text, setSwalProps, intl) => {
  const platform = localStorage.getItem("platform");
  const searchParams = new URLSearchParams(window.location.search);
  const isTelegram = searchParams.get("platform") === "telegram" || platform === "telegram";

  if (setSwalProps && intl) {
    setSwalProps({
      show: true,
      position: "bottom",
      text: intl.formatMessage({ id: "copySuccessfully" }),
      timer: 1000,
      showConfirmButton: false,
      toast: true,
      width: "13.2rem",
    });
  }

  if (isTelegram) {
    copyTextToClipboard(text);
  } else {
    try {
      navigator.clipboard.writeText(text);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('複製錯誤：', err);
      }

      document.body.removeChild(textArea);

    }
  }
};
